import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { HubConnection } from './service/chatHubService.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})

export class ChatComponent implements OnInit {
  showChatUser:boolean = false;
  showChatFiles:boolean = false;

  permissionAsssign: any[] = [];
  folderList: any[] = [];
  Module:string="";

  constructor(private router: Router,private _dataSharingService: DataSharingService,
    private ChatsignalRconnaction:HubConnection,) { }


    ngAfterViewInit() {
      this.ChatsignalRconnaction.createHubConnection();     
    }

  ngOnInit(): void {
    // this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions"));    
    // this.permissionAsssign =this.permissionAsssign.filter((x) => x.permissionName.toLowerCase() == 'menu chat');
    // if(this.permissionAsssign.length == 0){
    //   this.router.navigate(['unauthorised']);
    //   return;
    // }
    sessionStorage.setItem('edashboard', "false");
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));  
    this.permissionAsssign =this.permissionAsssign.filter((x) => x.mainModuleName == 'Chat' && x.isAssign==true);
    if(this.permissionAsssign.length == 0){
      this.router.navigate(['unauthorised']);
      return;
    }
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module =[];
    Module = menuModulesList.filter(x => x.mainModuleName == 'Chat');
    if(Module.length>0){
      this.Module= Module[0].orgModuleName;
    }
    
    sessionStorage.setItem('HeaderModuleName', this.Module);
    this._dataSharingService.sendSelectedModuleName(this.Module);
    this._dataSharingService.sendShowFormsSiderbar(this.Module);
  }

  chatUser(){
    this.showChatUser = !this.showChatUser
  }

  chatFiles(){
    this.showChatFiles = !this.showChatFiles
  }


}
